import type { TaskStatus } from '@ovo/shared'
import { statusLabel } from '../lib/status.ts'

// Статус передаётся формой знака и подписью, а не только цветом:
// новая ○, принята ◐, в работе ●, блокер ⏸, на проверке ✓, выполнена ✓✓, отклонена/отменена — зачёркнуто.

export function StatusGlyph({ status, size = 22 }: { status: TaskStatus; size?: number }) {
  return (
    <svg
      className={`status-glyph status-glyph--${status}`}
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {status === 'new' && <circle cx="11" cy="11" r="8.2" />}
      {status === 'accepted' && (
        <>
          <circle cx="11" cy="11" r="8.2" />
          <path d="M11 2.8a8.2 8.2 0 000 16.4z" fill="currentColor" stroke="none" />
        </>
      )}
      {status === 'in_progress' && (
        <>
          <circle cx="11" cy="11" r="8.2" />
          <circle cx="11" cy="11" r="5" fill="currentColor" stroke="none" />
        </>
      )}
      {status === 'blocked' && (
        <>
          <circle cx="11" cy="11" r="8.2" />
          <path d="M8.8 7.8v6.4M13.2 7.8v6.4" strokeWidth="2.2" />
        </>
      )}
      {status === 'submitted' && (
        <>
          <circle cx="11" cy="11" r="8.2" />
          <path d="M7.2 11.3l2.6 2.6 5-5.2" strokeWidth="2" />
        </>
      )}
      {status === 'done' && (
        <>
          <circle cx="11" cy="11" r="9" fill="currentColor" stroke="none" />
          <path d="M5.6 11.4l2.3 2.3 4.2-4.4M10.4 13.2l.5.5 4.9-5.1" stroke="#fff" strokeWidth="1.9" />
        </>
      )}
      {status === 'declined' && (
        <>
          <circle cx="11" cy="11" r="8.2" />
          <path d="M8 8l6 6M14 8l-6 6" />
        </>
      )}
      {status === 'cancelled' && (
        <>
          <circle cx="11" cy="11" r="8.2" strokeDasharray="3 2.6" />
          <path d="M6.5 15.5l9-9" />
        </>
      )}
    </svg>
  )
}

export function StatusBadge({ status }: { status: TaskStatus }) {
  return (
    <span className={`status-badge status-badge--${status}`}>
      <StatusGlyph status={status} size={18} />
      <span className="status-badge__label">{statusLabel(status)}</span>
    </span>
  )
}
